module.exports = __webpack_public_path__ + "img/oxidation-reduction-potential.d5a7de78.webp";